import { PendingChange } from '@/shared/config';

import { AssetID, ToothDetectionWithMetadata } from '../config';

export const extractChangesFromResult = (
  toothAndChangesWithIndices: Map<
    AssetID,
    Map<number, ToothDetectionWithMetadata[]>
  >,
): PendingChange[] => {
  const result: PendingChange[] = [];

  toothAndChangesWithIndices.forEach((isoMap) => {
    isoMap.forEach((detections) => {
      detections.forEach((detection) => {
        if (detection.change) {
          result.push(detection.change);
        }
      });
    });
  });

  return result;
};
